(function () {
  "use strict";
  if (window.__auZoom) return;
  window.__auZoom = true;

  var viewerFor = function (el) {
    var host = el.closest("[data-au-zoom-host], [data-au-pdp-gallery]");
    var id = host && (host.getAttribute("data-au-zoom-host") || host.getAttribute("data-id"));
    return id ? document.querySelector('dialog[data-au-zoom="' + CSS.escape(id) + '"]') : null;
  };

  var open = function (dialog, mediaId) {
    var track = dialog.querySelector("[data-au-zoom-track]");
    var slide = mediaId && track.querySelector('[data-media-id="' + mediaId + '"]');
    if (dialog.parentElement !== document.body) document.body.appendChild(dialog);
    dialog.showModal();
    track.scrollLeft = slide ? slide.offsetLeft : 0;
    sync(track);
  };

  var pauseAll = function (dialog, keep) {
    dialog.querySelectorAll(".au-zoom__slide").forEach(function (slide) {
      if (slide === keep) return;
      var v = slide.querySelector("video");
      if (v) v.pause();
      var f = slide.querySelector("iframe");
      if (f && f.contentWindow) {
        f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        f.contentWindow.postMessage('{"method":"pause"}', "*");
      }
    });
  };

  document.addEventListener("close", function (e) {
    if (e.target.matches && e.target.matches("dialog[data-au-zoom]")) pauseAll(e.target);
  }, true);

  var step = function (dialog, dir) {
    var track = dialog.querySelector("[data-au-zoom-track]");
    track.scrollBy({ left: dir * track.clientWidth, behavior: "smooth" });
  };

  var label = function (root) {
    root.querySelectorAll("[data-au-zoom-host] .product-media--root[data-media-type='image']").forEach(function (media) {
      var dialog = viewerFor(media);
      if (!dialog || media.hasAttribute("tabindex")) return;
      media.setAttribute("tabindex", "0");
      media.setAttribute("role", "button");
      media.setAttribute("aria-label", dialog.getAttribute("aria-label"));
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { label(document); });
  else label(document);
  document.addEventListener("shopify:section:load", function (e) { label(e.target); });

  document.addEventListener("au:zoom", function (e) {
    var dialog = viewerFor(e.target);
    if (!dialog) return;
    e.preventDefault();
    open(dialog, e.detail && e.detail.mediaId);
  });

  document.addEventListener("click", function (e) {
    var media = e.target.closest("[data-au-zoom-host] .product-media--root[data-media-type='image']");
    if (media) {
      var host = viewerFor(media);
      if (host) open(host, media.getAttribute("data-id"));
      return;
    }
    var dialog = e.target.closest("dialog[data-au-zoom]");
    if (!dialog) return;
    if (e.target.closest("[data-au-zoom-close]")) dialog.close();
    else if (e.target.closest("[data-au-zoom-prev]")) step(dialog, -1);
    else if (e.target.closest("[data-au-zoom-next]")) step(dialog, 1);
  });

  document.addEventListener("keydown", function (e) {
    var media = e.target.closest && e.target.closest("[data-au-zoom-host] .product-media--root[data-media-type='image']");
    if (media && (e.key === "Enter" || e.key === " ")) {
      e.preventDefault();
      var host = viewerFor(media);
      if (host) open(host, media.getAttribute("data-id"));
      return;
    }
    if (e.key !== "ArrowLeft" && e.key !== "ArrowRight") return;
    var dialog = document.querySelector("dialog[data-au-zoom][open]");
    if (!dialog) return;
    e.preventDefault();
    step(dialog, e.key === "ArrowRight" ? 1 : -1);
  });

  var sync = function (track) {
    var i = Math.round(track.scrollLeft / track.clientWidth);
    var dialog = track.closest("dialog");
    pauseAll(dialog, track.children[i]);
    var counter = dialog.querySelector("[data-au-zoom-index]");
    if (counter) counter.textContent = i + 1;
    dialog.querySelector("[data-au-zoom-prev]").setAttribute("aria-disabled", i === 0);
    dialog.querySelector("[data-au-zoom-next]").setAttribute("aria-disabled", i >= track.children.length - 1);
  };

  document.addEventListener(
    "scroll",
    function (e) {
      if (e.target.matches && e.target.matches("[data-au-zoom-track]")) sync(e.target);
    },
    { capture: true, passive: true }
  );
})();
